module.exports = __webpack_public_path__ + "static/media/broom.fafccd11.svg";